import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Notice } from '../../models/notice.model';
import * as noticeActions from '../actions/notice.actions';

export interface NoticeState extends EntityState<Notice> {
  loading: boolean;
  loaded: boolean;
  inProgress: boolean;
  //   noticeStatsLoading: boolean;
  error: AppExceptionModel | undefined;
}

export const noticeAdapter: EntityAdapter<Notice> =
  createEntityAdapter<Notice>();

export const initialState: NoticeState = noticeAdapter.getInitialState({
  loading: false,
  loaded: false,
  inProgress: false,
  noticeStatsLoading: false,
  error: undefined,
});

export const noticeReducer = createReducer(
  initialState,
  on(noticeActions.getNotices, (state, {}) => ({
    ...state,
    loading: true,
    loaded: false,
    error: undefined,
  })),
  on(noticeActions.getNotice, (state, {}) => ({
    ...state,
    error: undefined,
  })),
  on(noticeActions.addNoticesToStore, (state, { notices }) => {
    if (notices?.length > 0) {
      return noticeAdapter.upsertMany(notices, {
        ...state,
        loading: false,
        loaded: true,
        inProgress: false,
        error: undefined,
      });
    } else {
      return {
        ...state,
        loading: false,
        loaded: true,
        inProgress: false,
        error: undefined,
      };
    }
  }),
  on(noticeActions.addNoticeToStore, (state, { notice }) =>
    noticeAdapter.upsertOne(notice, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(noticeActions.getNoticesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: error,
  })),
  on(noticeActions.create, (state, { notice }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(noticeActions.createSuccess, (state, { notice }) =>
    noticeAdapter.upsertOne(notice, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(noticeActions.createFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(noticeActions.update, (state, { notice }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(noticeActions.updateSuccess, (state, { notice }) =>
    noticeAdapter.upsertOne(notice, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(noticeActions.updateFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(noticeActions.updateStatus, (state, { notice }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(noticeActions.updateStatusSuccess, (state, { notice }) =>
    noticeAdapter.upsertOne(notice, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(noticeActions.updateStatusFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(noticeActions.deleteAction, (state, { id }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(noticeActions.deleteSuccess, (state, { id }) =>
    noticeAdapter.removeOne(id, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(noticeActions.deleteFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  //   on(noticeActions.getNoticeStats, (state) => ({
  //     ...state,
  //     noticeStatsLoading: true,
  //   })),
  //   on(noticeActions.getNoticeStatsDone, (state) => ({
  //     ...state,
  //     noticeStatsLoading: false,
  //   })),
  //   on(noticeActions.getNoticeStatsFailure, (state) => ({
  //     ...state,
  //     noticeStatsLoading: false,
  //   })),
  on(noticeActions.clear, (state) => initialState),
);
